import React from "react";
import label from "../../labels/recommendationProcess_en.json";

const Merit = () => {
  return (
    <div className="dashboardContentArea">
      <h5> {label.Merit} </h5>
      <div className="row dashboardCards"></div>
    </div>
  );
};

export default Merit;
